import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

export default function Faq() {
  return (
    <Section id="faq" data-testid="faq">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <SectionHeading overline="Questions" title={<>Frequently asked questions</>} />
          <p className="mt-6 text-base leading-relaxed text-white/55">
            RestPower is an early-stage concept in development. Here's an honest look at where things stand.
          </p>
        </Reveal>

        <Reveal delay={0.08} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-${i}`}>
                <AccordionTrigger className="py-5 text-left font-display text-lg font-medium tracking-tight text-white hover:text-rp-accent hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-white/55">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </Section>
  );
}
